export default {"src":"/_next/static/media/ic-show-gray.1f5892c6.svg","height":9,"width":13,"blurWidth":0,"blurHeight":0};